import { useEffect, useState } from 'react';

const VideoBackground = () => {
  const [icons, setIcons] = useState<Array<{
    id: number;
    icon: string;
    x: number;
    y: number;
    speed: number;
    color: string;
    size: string;
  }>>([]);

  const socialIcons = [
    { icon: 'ri-facebook-fill', color: 'text-blue-500' },
    { icon: 'ri-instagram-fill', color: 'text-pink-500' },
    { icon: 'ri-twitter-x-fill', color: 'text-blue-400' },
    { icon: 'ri-linkedin-fill', color: 'text-blue-600' },
    { icon: 'ri-youtube-fill', color: 'text-red-500' },
    { icon: 'ri-tiktok-fill', color: 'text-cyan-400' },
    { icon: 'ri-pinterest-fill', color: 'text-red-600' },
    { icon: 'ri-snapchat-fill', color: 'text-yellow-400' },
    { icon: 'ri-whatsapp-fill', color: 'text-green-500' },
    { icon: 'ri-telegram-fill', color: 'text-blue-400' },
  ];

  const sizes = ['text-4xl', 'text-5xl', 'text-6xl', 'text-7xl'];

  useEffect(() => {
    const initialIcons = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      icon: socialIcons[i % socialIcons.length].icon,
      color: socialIcons[i % socialIcons.length].color,
      x: Math.random() * window.innerWidth,
      y: window.innerHeight + Math.random() * 500,
      speed: 0.8 + Math.random() * 2,
      size: sizes[Math.floor(Math.random() * sizes.length)],
    }));
    setIcons(initialIcons);

    const animateIcons = () => {
      setIcons(prevIcons =>
        prevIcons.map(icon => {
          let newY = icon.y - icon.speed;
          
          // Reset icon to bottom when it goes off screen at top
          if (newY < -150) {
            return {
              ...icon,
              y: window.innerHeight + 100 + Math.random() * 200,
              x: Math.random() * window.innerWidth,
              speed: 0.8 + Math.random() * 2,
            };
          }

          return {
            ...icon,
            y: newY,
          };
        })
      );
    };

    const interval = setInterval(animateIcons, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {icons.map(icon => (
        <div
          key={icon.id}
          className={`absolute transition-all duration-75 ${icon.color} ${icon.size} opacity-10`}
          style={{
            left: `${icon.x}px`,
            top: `${icon.y}px`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <i className={icon.icon}></i>
        </div>
      ))}
    </div>
  );
};

export default VideoBackground;
